import { getFederatedDebug } from '@/common/debug';
import axios from 'axios';

import { isSSRServer } from '@/config';

import { init, loadRemote } from '@module-federation/enhanced/runtime';

import * as Vue from 'vue';

const shared = {
    vue: {
        version: '3.3.4',
        scope: 'default',
        lib: () => Vue,
        shareConfig: {
            singleton: true,
            requiredVersion: '^3.3.4',
        },
    }
};

const getWebpackFederatedComponent = async function({ remoteUrl, componentName, scope = "dynamic", unwrapDefault = true, shareScope }) {
    if (!isSSRServer) {
        init({
            remotes: [
                {
                    name: scope,
                    alias: scope,
                    entry: remoteUrl,
                }
            ],
            shared: shared,
        });
        if (componentName.startsWith('./')) {
            componentName = componentName.slice(1);
        }
        const remote = await loadRemote(`${scope}${componentName}`);
        if (unwrapDefault) {
            return remote.default || remote;
        }
        return remote;
    }
}

//  Obtain  url
const getFederatedInfo = async function({ blockid, scope }) {
    try {
        let res = await axios.get(`/api/site-plugin/version/getAppCurrentVersion`, {
            params: { appId: blockid }
        });
        let data = JSON.parse(res.data?.data || '{}');
        let federation = data.federation || [];
        for (let i = 0; i < federation.length; i++) {
            let item = federation[i];
            if (item.scope === scope) {
                return {
                    url: item.remoteUrl || '',
                    from: data.from || 'webpack',
                };
            }
        }
        console.log(federation, scope);
    } catch (e) {
        console.error("getFederatedInfo error", e);
    }
    return '';
};


const getFederatedComponentApp = async function({ remoteUrl, scope, componentName, blockid }) {
    try {
        let form = 'webpack';
        if (!(getFederatedDebug() && remoteUrl)) {
            let info = await getFederatedInfo({
                blockid: blockid,
                scope: scope
            });
            if (info) {
                remoteUrl = info.url;
                form = info.form;
            }
        }
        if (!remoteUrl || !componentName || !scope) {
            console.log('Remote URL is empty');
            return;
        }
        let com = await getFederatedComponent({
            form,
            remoteUrl: remoteUrl,
            componentName: componentName,
            scope,
        });
        return com;
    } catch (e) {
        console.error("getFederatedComponentApp error", e);
    }
};

const componentCache = new Map();
const getFederatedComponent = async({ remoteUrl, scope, componentName, from = 'webpack' }) => {
    const key = `${remoteUrl}-${scope}-${componentName}-${from}`;
    let cache = componentCache.get(key);
    if (cache) {
        return cache;
    }
    let Comp;
    // if(from == 'vite'){
    //     Comp = await getViteFederatedComponent({remoteUrl,componentName});
    // }else{
    //     Comp =  await getWebpackFederatedComponent({remoteUrl,scope,componentName});
    // }
    Comp =  await getWebpackFederatedComponent({ remoteUrl, scope, componentName });
    if (Comp && Comp.default) {
        Comp = Comp.default;
    }
    componentCache.set(key, Comp);
    return Comp;
} 

export {
    getFederatedInfo,
    getFederatedComponentApp,
    getFederatedComponent
}

